import type { HTMLAttributes, PropsWithChildren } from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import { useSettings } from '@wu/widget-core';

type ContentBlockProps = HTMLAttributes<HTMLDivElement> &
  PropsWithChildren<{ withDivider?: boolean }>;

export const DividerBlock = forwardRef<HTMLDivElement, ContentBlockProps>(
  function DividerBlock(
    { children, withDivider = true, ...forwardingProps },
    forwardingRef
  ) {
    const { textColor } = useSettings();
    return (
      <Container
        {...forwardingProps}
        ref={forwardingRef}
        _color={withDivider ? getColorWithAlpha(textColor, 0.1) : 'transparent'}
      >
        {children}
      </Container>
    );
  }
);

const Container = styled.div<{ _color: string }>`
  border-bottom: ${({ _color }) => `1px solid ${_color}`};
  border-top: ${({ _color }) => `1px solid ${_color}`};
  & + & {
    border-top: none;
  }
`;
